import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { PlatformEnum } from 'src/app/utils/platform.utils';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {
  constructor(private platform: Platform) {}

  getPlatform(): PlatformEnum {
    if (this.platform.is('hybrid')) {
      if (this.platform.is('ios')) {
        return PlatformEnum.IOS;
      } else if (this.platform.is('android')) {
        return PlatformEnum.ANDROID;
      }
    } else {
      return PlatformEnum.BROWSER;
    }
  }
}
